<!-- Crawl功能 -->
<template>
  <div class="CrawlSingular">
    <el-dialog
      title="Crawl"
      :visible.sync="syncSwitch"
      width="979px"
      :center="true"
      :close-on-click-modal="false"
      @close="cancel"
      :destroy-on-close="true"
    >
      <div
        class="SingularWrap"
        v-loading="CrawlLoading">
        <div class="SingularMenu">
          <div class="CrawlBGC" >
            <el-checkbox v-model="setBgc" @change="BgcChange">BG&C</el-checkbox>
          </div>
          <iframe
            id="menuDom"
            :src="menuUrl"
            frameborder="0"
            class="iframe"
          ></iframe>
        </div>
        <div class="SingularPreview">
          <div class="Preview">
            <iframe
              :src="pvwUrl"
              frameborder="0"
              class="iframe"
              id="SingularPrevieW"
            ></iframe>
          </div>
          <div class="Operation">
            <el-button
              type="info"
              class="Cancel"
              @click="cancel"
            >{{ $t('lang.cancel') }}</el-button
            >
            <el-button
              type="success"
              class="Save"
              @click="save">{{ $t('lang.save') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    // 开关
    OverlaySwitch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setBgc: false,
      menuUrl: '',
      pvwUrl: '',
      CrawlLoading: true,
      syncSwitch: true
    }
  },
  created () {
  },
  watch: {
    syncSwitch (value) {
      if (!value) {
        this.$emit('closeCrawl')
      }
    }
  },
  mounted () {
    this.getoverlayUrl()
  },
  methods: {
    // 获取iframe的url
    getoverlayUrl () {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/crawl/getOverlayUrl', {
        entityType: 0,
        entityId: this.$BehaviorSyns.getProgramId()
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.menuUrl = res.data.result.menuUrl
          this.pvwUrl = res.data.result.pvwUrl
          this.judgeLoading()
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/program/BGC/getSwitchStatus').then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            this.setBgc = !!res.data.result.setBgc
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    },
    // 判断iframe是否加载成功
    judgeLoading () {
      this.$nextTick(() => {
        const menuDom = document.getElementById('menuDom')
        menuDom.onload = (e) => {
          // console.log(e.target.contentWindow.document,'lllllllll')
          this.CrawlLoading = false
        }
      })
    },
    // 关闭弹窗
    cancel () {
      this.$emit('closeCrawl')
    },
    // Bgc发生变化就调接口
    BgcChange () {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/program/BGC/switch', {
        setBgc: this.setBgc ? 1 : 0
      }).then((res) => {
        if (res.data.errorCode !== '0x0') {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      })
    },
    // 发送改动到r
    save () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/crawl/getCrawlMessage', {
        entityType: 0,
        entityId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const widgets = JSON.parse(res.data.result).scene.preview.widgets
            let NameIsNull = false
            if (widgets && widgets.length > 0) {
              widgets.forEach((item) => {
                if (!item.properties.widgetName && item.isShown) {
                  NameIsNull = true
                }
              })
            }
            if (NameIsNull) {
              this.$message.error(this.$t('lang.provideCrawl'))
            } else {
              this.$confirm(this.$t('lang.ifSaveCrawl'), '', {
                confirmButtonText: this.$t('lang.confirm'),
                cancelButtonText: this.$t('lang.close')
              }).then(() => {
                this.axios.post('/gatewayPlayoutUrl/tvu-playout/crawl/applyChanges', {
                  entityType: 0,
                  entityId: this.$BehaviorSyns.getProgramId()
                }).then((res2) => {
                  if (res2.data.errorCode == '0x0') {
                    this.$emit('closeCrawl')
                  } else {
                    const errorInfo = this.$t(toTips[res2.data.errorCode]) || res2.data.errorInfo
                    this.$message.info(errorInfo)
                  }
                }).catch()
              })
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    }
  }
}
</script>

<style scoped lang="less">
.CrawlSingular {
  background: #252525;
  ::v-deep.el-dialog__body {
    padding: 0;
  }
  .SingularWrap {
    display: flex;
    justify-content: space-between;
    height: 520px;
    .SingularMenu {
      width: 288px;
      height: 513px;
      background: #252525;
      .CrawlBGC{
        margin:13px 0 0 15px;
        ::v-deep.el-checkbox__label{
          color: #DBDBDB;
        }
        ::v-deep.el-checkbox__inner{
          background: #333333;
          border: 1px solid #666666;
        }
      }
      .iframe {
        width: 100%;
        height: 90%;
      }
    }
    .SingularPreview {
      .Preview {
        width: 643px;
        height: 367px;
        background: #000000;
      }
      .Operation {
        display: flex;
        justify-content: flex-end;
        margin-top: 100px;
        .el-button {
          width: 100px;
          height: 36px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .Cancel {
          background: #cccccc;
        }
        .Save {
          background: #00cc66;
          border: 1px solid #0f620a;
        }
      }
    }
  }
  #menuDom{
   ::v-deep li{
      display: none !important;
    }
  }
}
</style>
